export default __webpack_public_path__ + "static/media/industry.cad5630a.svg";